module.exports = __webpack_public_path__ + "img/calendar-bg.ec7d6552.svg";